import React from "react";

export default function Agreements() {
  return (
    <div className="policyPage">
      <div className="policyPage__text">
        <h2>Agreements</h2>
        <p>
          This is legal agreements between You and  X-Cloud Solutions and You
          agrees with following Terms and Conditions to use our Innovations
          offered services / hosted applications.
        </p>
        <br />
        <br />
        <p>
          Following are the abbreviation used in this document <br />
          USER: refer to You, an individual or organization utilizing
          the  X-Cloud Solutions hosted software and services
        </p>
        <p>
          SYSTEM: refer to  X-Cloud Solutions Innovations's hosted platform and
          resources needed to offer hosted software and services to USERS like
          Web sites , Dedicated Servers, Domain name, IP Address Range, Content,
          Bandwidth, Storage , Network and hosted software and attached
          peripherals.
        </p>
        <h5>Registration Obligations</h5>
        <p>
          While registering to SYSTEM , USER agrees to provide true , accurate ,
          current and complete information about himself and will promptly
          update these information in case of any change to keep it current ,
          true , accurate and complete
        </p>
        <h5>USER data protection</h5>
        <p>
          USER will be fully responsible to keep the confidentiality of all
          access credentials and others account information provided by  X-Cloud
          Solutions or SYSTEM and will be fully responsible for all activities
          that occur under USER's hosted platform ( hosted software and services
          )
        </p>
        <p>
          USER agrees to immediately notify  X-Cloud Solutions of any
          unauthorized use of user passwords and account or any other security
          breach,  X-Cloud Solutions will not be responsible for any loss or
          damage arising from USER failure to comply with these obligations
        </p>
        <h5>Permitted Use</h5>
        <p>
          This SYSTEM is provided as on an “as is” basis by  X-Cloud
          Solutions for the convenience of its USERS and the SYSTEM and all
          copyrights, trademarks and other proprietary and personal rights of
          the SYSTEM is the sole property of  X-Cloud Solutions. The SYSTEM is
          intended for use by persons 18 years of age or older.
        </p>
        <h5>Responsible Use</h5>
        <p>
          USER agrees to follow all applicable local as well as international
          laws, rules and regulations while using the SYSTEM, the USER agrees to
          consult with his legal adviser before using SYSTEM to make sure that
          all legalities and regulations have been fulfilled USER agrees to be
          fully responsible to make sure that all users under his account /
          hosted application using the hosted software will be under his
          responsibility, the USER also make sure that users under his account /
          hosted application follow Terms of Use mentioned in this document and
          will take written consent from each user before providing access to
          the hosted application USER will make sure that he has proper rights
          of all contents provided / uploaded to SYSTEM and will provide /
          upload own sound files / Fax Documents / SMS Message / Email contents
          to run campaigns USER agrees to schedule campaigns responsibly and
          will take care of Time Zones of the recipients USER agrees not to send
          any calls to life-line services, Emergency services such as hospitals,
          fire, police and 911 etc USER agrees to not send any telemarketing
          calls to recipients that have not consented to receive such a
          broadcast. USER agrees to use DNC / opt-out features made available to
          USER via SYSTEM.
        </p>
        <h5>Copy Rights</h5>
        <p>
          All contents and Software's used in  X-Cloud Solutions SYSTEM are copy
          righted and user agrees to fully comply with International copyrights
          and trad marks and others applicable laws
        </p>
        <h5>Termination of Services</h5>
        <p>
           X-Cloud Solutions reserve the right to terminate services of any USER
          any time with or without prior notice especially if USER is found to
          be in violation of  X-Cloud Solutions terms and conditions
        </p>
        <p>
           X-Cloud Solutions reserve the right to refuse to offer his services
          to any USER without giving any reason USER agrees that  X-Cloud
          Solutions will not be liable to USER or any third party for
          modification, suspension or discontinuation of service
        </p>
        <h5>Payment</h5>
        <p>
           X-Cloud Solutions offer prepaid services and USER use of service is
          contingent on USER paying in advance for such use according to current
          pricing of products and services and USER will make sure that all dues
          / fee is paid in time
        </p>
        <p>
          User expressively understand and agree that ict shall not be liable
          for any direct , indirect , incidental, special, consequential damage
          including but not limited to damage for loss of profits , goodwill ,
          use , data or other intangible losses resulting from:
        </p>
        <p>
          X-Cloud Solutions shall not be responsible for any errors or
          transmission failures with regard to charging and collection of funds
          from USER payment method nor for any actions taken by the payment
          method / provider that USER chooses.
        </p>
        <p>
          X - Cloud Solutionsreserve right to change price of his products and
          services any time and it is sole discretion of X - Cloud Solutions to
          publish such change in price at his websites.
        </p>
        <p>
          All payment made by USER will be subjected to the agreement between
          USER and the provider of the payment method in addition to these terms
        </p>
        <h5>Modification</h5>
        <p>
           X-Cloud Solutions reserve the right to modify the SYSTEM ,
          discontinue SYSTEM or any part of SYSTEM temporarily or permanently,
          change policies and these terms and conditions at any time with or
          without prior notice to USERS.
        </p>
        <h5>Emergency Services</h5>
        <p>
           X-Cloud Solutions does not provide any kind of emergency services
        </p>
        <h5>Applicable Law</h5>
        <p>
          USER agree to use SYSTEM following applicable law of his region and
          communications network (origination and destination ) and agrees not
          to use SYSTEM for illegal purpose and will be fully responsible for
          the consequence of such illegal usage
        </p>
        <p>
          This Terms and Condition constitutes the entire agreement between USER
          and governs USER use of the SYSTEM, superseding any prior agreements
          between  X-Cloud Solutions and USER. This agreement and the
          relationship between USER AND  X-Cloud Solutions shall be governed by
          the Region where  X-Cloud Solutions has registered head office.
        </p>
        <p>
          The failure of  X-Cloud Solutions to exercise or enforce any right or
          provision of this agreement shall not constitutes waiver of such right
          or provision
        </p>
      </div>
      <div className="policyPage__image">
        <img src="/images/agreementsImage.png" alt="" />
      </div>
    </div>
  );
}
